
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class ReportPendingPODtDialog extends  Serenity.Extensions.GridEditorDialog<ReportPendingPODtRow> {
        protected getFormKey() { return ReportPendingPODtForm.formKey; }
        protected getIdProperty() { return ReportPendingPODtRow.idProperty; }
        protected getLocalTextPrefix() { return ReportPendingPODtRow.localTextPrefix; }
        protected getNameProperty() { return ReportPendingPODtRow.nameProperty; }
        protected getService() { return ReportPendingPODtService.baseUrl; }
        protected getDeletePermission() { return ReportPendingPODtRow.deletePermission; }
        protected getInsertPermission() { return ReportPendingPODtRow.insertPermission; }
        protected getUpdatePermission() { return ReportPendingPODtRow.updatePermission; }

        protected form = new ReportPendingPODtForm(this.idPrefix);
        protected getToolbarButtons(): Serenity.ToolButton[] {

            let buttons = super.getToolbarButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
           buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
           buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
           return buttons;


            }

    }
}